import { ButtonProps } from "~/ui/button"

export function Button({ children }: ButtonProps) {
  return (
    <button className="flex h-12 w-full items-center justify-center rounded-full border border-base-black bg-support-yellow px-6 py-3 text-base-black shadow-md md:px-8">
      <div className="font-md-nichrome text-18 font-medium uppercase leading-8 text-base-black md:text-20">
        {children}
      </div>
    </button>
  )
}
